
























































































































import Vue from 'vue';
import { FormFieldValidation, RouteHelpers } from '@/mixins';
import {
  BaseResultModel,
  ScriveTemplateSigningPartyFieldModel,
  Configuration,
  Dictionary,
  ScriveTemplateSigningPartyFieldCreateUpdateModel,
  ScriveTemplateSigningPartyFieldSearchModel,
  ScriveSigningPartyFieldType
} from '@/types';
import { ScriveConfigurationService } from '@/services/scrive/ScriveConfigurationService';
import SnotifyConfiguration from '@/classes/SnotifyConfiguration';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import MStoreSpinnerButton from '@/components/shared/MStoreSpinnerButton.vue';
import MStoreFormGroup from '@/components/shared/MStoreFormGroup.vue';
import MStoreFormRadioButtonGroup from '@/components/shared/MStoreFormRadioButtonGroup.vue';

export default Vue.extend({
  name: 'ScriveAddSigningPartyField',
  mixins: [FormFieldValidation, RouteHelpers],
  data() {
    return {
      isLoading: true,
      templateSigningPartyField: {
        type: ScriveSigningPartyFieldType.Signature
      } as ScriveTemplateSigningPartyFieldModel,
      submitIsLoading: false,
      saveAndAddPlacementSubmitting: false,
      signingPartyFieldId: null,
      hasError: false,
      errorMessage: '',
      navigateFunction: (): void => {
        console.log('The field navigateFunction is not implemented');
      }
    };
  },
  methods: {
    async onSubmit(this: any, setSubmittingState: (state: boolean) => void) {
      this.resetFormValidation();
      try {
        setSubmittingState(true);
        const result: BaseResultModel = await ScriveConfigurationService.createSigningPartyFieldAsync({
          templateSigningPartyId: this.signingPartyId,
          description: this.templateSigningPartyField.description,
          fieldName: this.templateSigningPartyField.fieldName,
          type: this.templateSigningPartyField.type
        } as ScriveTemplateSigningPartyFieldCreateUpdateModel);

        if (result.hasNotification && !result.showToast) {
          this.addFormValidationError(result.notification);
          setSubmittingState(false);
          return;
        }

        this.signingPartyFieldId = result.id;

        SnotifyConfiguration.showSuccess('Signing Party Field created successfully.');
        this.setApplicationDirty(false);
        this.navigateFunction();
      } catch (error) {
        this.$log('Error creating signing party', error);
      } finally {
        setSubmittingState(false);
      }
    },
    async getDataAsync(this: any) {
      this.isLoading = true;
      try {
        // tslint:disable-next-line:max-line-length
        await ScriveConfigurationService.getTemplateSigningPartyFieldConfigurationAsync({
          templateSigningPartyFieldId: null
        } as ScriveTemplateSigningPartyFieldSearchModel);
      } catch (error) {
        this.$log('Error getting signing party');
      } finally {
        this.isLoading = false;
      }
    },
    onCancel(this: any) {
      this.navigateToEditSigningParty();
    },
    navigateToEditSigningParty(this: any) {
      const param = {} as Dictionary<any>;
      param.documentTypeId = this.documentTypeId;
      param.templateId = this.templateId;
      param.id = this.signingPartyId;

      this.$router.push({
        name: Configuration.Scrive.SigningParty.Edit.name,
        params: param
      });
    },
    navigateToAddFieldPlacement(this: any) {
      const param = {} as Dictionary<any>;
      param.documentTypeId = this.documentTypeId;
      param.templateId = this.templateId;
      param.signingPartyId = this.signingPartyId;
      param.signingPartyFieldId = this.signingPartyFieldId;
      this.$router.push({
        name: Configuration.Scrive.SigningPartyFieldPlacement.Add.name,
        params: param
      });
    },
    setSaveSubmittingState(this: any, state: boolean) {
      this.submitIsLoading = state;
    },
    setSaveAndAddPlacementSubmittingState(this: any, state: boolean) {
      this.saveAndAddPlacementSubmitting = state;
    }
  },
  computed: {
    documentTypeId(): number {
      return Number(this.$route.params.documentTypeId);
    },
    templateId(): number {
      return Number(this.$route.params.templateId);
    },
    signingPartyId(): number {
      return Number(this.$route.params.signingPartyId);
    },
    templateSigningPartyFieldType: {
      get(this: any) {
        return (this.templateSigningPartyField as ScriveTemplateSigningPartyFieldModel).type?.toString();
      },
      set(value: number) {
        (this.templateSigningPartyField as ScriveTemplateSigningPartyFieldModel).type = value.toString() as ScriveSigningPartyFieldType;
      }
    }
  },
  mounted(this: any) {
    this.getDataAsync();
  },
  created(this: any) {
    this.templateSigningPartyFieldTypes = [
      {
        value: ScriveSigningPartyFieldType.Signature,
        text: 'Signature'
      },
      {
        value: ScriveSigningPartyFieldType.SignatureDate,
        text: 'Date'
      }
    ];
  },
  components: {
    LoadingSpinner,
    MStoreSpinnerButton,
    MStoreFormGroup,
    MStoreFormRadioButtonGroup
  }
});
